import useTranslation from '@/hooks/useTranslation'
import styles from './vehicleSelector.module.scss'
import { Modal, Button } from 'rsuite'

const ExternalWebsiteRedirectModal = ({ show, close, url }) => {
  const t = useTranslation()
  const redirect = () => {
    window.open(url, '_blank', 'noopener,noreferrer')
    close()
  }
  return (
    <Modal open={show} onClose={close}>
      <Modal.Header>
        <Modal.Title>{t('homepage_external_website_redirect', 'External Website Redirect')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            {t('homepage_external_website_redirect_message', 'You are being redirected to another subaru.com website')}
          </p>
          <p className={styles.externalWebsiteUrl}>{url}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={redirect} appearance="primary">
          {t('homepage_external_website_redirect_button', 'Go to the website')}
        </Button>
        <Button onClick={close}>{t('homepage_external_website_redirect_cancel_button', 'Stay here')}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ExternalWebsiteRedirectModal
